import { PolicyPaperlessDetailsV2 } from "@hagerty/customer-insurance-gateway-client";

export const createPaperlessDetails = (
  email?: string,
  status: PolicyPaperlessDetailsV2["status"] = "INACTIVE"
): PolicyPaperlessDetailsV2 => {
  return { email, status };
};
